import { render, staticRenderFns } from "./LetterAvatar.vue?vue&type=template&id=025dad3f&scoped=true"
import script from "./LetterAvatar.vue?vue&type=script&lang=ts"
export * from "./LetterAvatar.vue?vue&type=script&lang=ts"
import style0 from "./LetterAvatar.vue?vue&type=style&index=0&id=025dad3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025dad3f",
  null
  
)

export default component.exports